import CardLinks from './card-links'

export default CardLinks
